import { defineMessages } from 'react-intl';

export default defineMessages({
    repaymentsOverMonths: {
        id: '_.draw_down.choose_amount.your_repayments_over_months',
        defaultMessage: `{isAccessUser, select,
        true {Repayments}
        false {Your repayments}
        other {}
        } over {months} months`
    },
    myRepaymentSchedule: {
        id: '_.draw_down.choose_amount.my_repayment_schedule',
        defaultMessage: 'See my repayment schedule'
    },
    interestRateLabel: {
        id: '_.draw_down.choose_amount.interest_rate_label',
        defaultMessage: 'Interest rate'
    },
    interestRatePeriod: {
        id: '_.draw_down.choose_amount.interest_rate_period',
        defaultMessage: 'per 30 days'
    },
    interestOnlySubtitle: {
        id: '_.draw_down.choose_amount.interest_only_subtitle',
        defaultMessage: '(includes 3 months interest-only)'
    },
    totalInterestLabel: {
        id: '_.draw_down.choose_amount.total_interest',
        defaultMessage: 'Total interest'
    },
    totalRepaymentLabel: {
        id: '_.draw_down.choose_amount.total_repayment',
        defaultMessage: 'Total repayment'
    },
    discountedOffer: {
        id: '_.draw_down_.discountedOffer',
        defaultMessage: 'Our offer for you:'
    }
});
